var module = angular.module('octopusApp.infrastructure');

// Manages who the current user is
module.factory('octopusAuthenticator', function () {
  return {
    currentUser: function (newValue) {
      if (typeof (newValue) !== "undefined") {
        Octopus.App.currentUser = newValue;
        Octopus.App.currentPermissionSet = null;
      }

      if (typeof (Octopus.App.currentUser) === "undefined") {
        return null;
      }

      return Octopus.App.currentUser;
    },
    setCurrentPrincipal: function(user, permissionSet) {
      Octopus.App.currentUser = user;
      Octopus.App.currentPermissionSet = permissionSet;
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/services/octopus_authenticator.js
// module id = 700
// module chunks = 1